import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { INVENTARIOS_ENTRADASALIDA_LISTA, INVENTARIOS_ENTRADASALIDA_NUEVO } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'

export default function InventariosEntradaSalidaPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${INVENTARIOS_ENTRADASALIDA_LISTA}`} component={ListaPage} />
        <Route path={`/${INVENTARIOS_ENTRADASALIDA_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${INVENTARIOS_ENTRADASALIDA_NUEVO}`} component={NuevoPage} />
      </Switch>
    </Suspense>
  )
}
